import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { AppV5StateService } from '@service/app-v5/app-v5-state.service';
import { SearchMusicChannelService } from '@service/search-music-channel.service';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';



@Component({
    selector: 'tun-search-music-channels-view',
    templateUrl: './search-music-channels-view.component.html',
    styleUrls: ['./search-music-channels-view.component.scss'],
    standalone: false
})
export class SearchMusicChannelsViewComponent implements OnDestroy {

  public colors : string[] = [
    "#f6836a", //orange1
    "#75ACFF", //blue1
    "#49CE8F", //green1
    "#7890C9", //purple1

    "#e66e92", //orange2
    "#8595ee", //blue2
    "#00bc98", //green2
    "#7f81bf", //purple2

    "#b66db4", //orange3
    "#947dd9", //blue3
    "#00a89d", //green3
    "#8771b2", //purple3

    "#a163be", //blue4
    "#00949f", //green4
    "#8f60a1", //purple4
  ];

  public colorForIndex(index: number){
    return this.colors[index % this.colors.length];
  }


  @Output() startSearchText = new EventEmitter<void>();

  public get searchMusicChannelGroupsLoading$(){
    return this.searchMusicChannelService.loading$
  }

  public get searchMusicChannelGroupsError$(){
    return this.searchMusicChannelService.loadingError$
  }

  public get searchMusicChannels$(){
    return this.searchMusicChannelService.musicChannelGroups$
    .pipe(
      map(musicChannelGroups=>{
        const musicChannels = []
        if (musicChannelGroups){
          musicChannelGroups.forEach(musicChannelGroup => {
            musicChannels.push(...musicChannelGroup.musicChannels)
          });
        }

        return musicChannels
      })
    )
  }

  constructor(
    private searchMusicChannelService: SearchMusicChannelService,
    private appV5StateService: AppV5StateService
  ) {
    if (this.searchMusicChannelService.musicChannelGroups == null && !this.searchMusicChannelService.loading){
      this.searchMusicChannelService.loadMusicChannelGroups();
    }
  }

  private destroyed$ = new Subject<void>();
  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
    this.destroyed$ = null;
  }

  public onRetry(){
    this.searchMusicChannelService.loadMusicChannelGroups();
  }

  public onSearchText(){
    this.appV5StateService.openTextSearch(true);
  }

}
